import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { LegalGuardianType } from '../../../../../core';

@JsonConverter
export class LegalGuardianTypeAdapter implements JsonCustomConvert<LegalGuardianType | undefined> {
    serialize(type: LegalGuardianType): any | undefined {
        return type ? String(type) : undefined;
    }

    deserialize(type: any): LegalGuardianType | undefined {
        switch (type) {
            case 'Tutor':
                return LegalGuardianType.TUTOR;
            case 'AttorneyInFact':
                return LegalGuardianType.ATTORNEY_IN_FACT;
            default:
                return undefined;
        }
    }
}
